import { useOptimisticSearchParams } from 'nuqs/adapters/react-router/v6'

export type UseUrlSearchParamsResult = {
  searchParams: URLSearchParams
  urlParams: string
}

export const useUrlSearchParams = (): UseUrlSearchParamsResult => {
  const searchParams: URLSearchParams = useOptimisticSearchParams()
  const urlParams: string = searchParams.toString() ? `?${searchParams.toString()}` : ''

  return {
    searchParams,
    urlParams,
  }
}
